const Vue = require('vue').default
const moment = require("moment")
const axios = require("axios")
const global = Function("return this")();
const QueryString = require('../lib/QueryString').default;
//二次元配列の転置
const transpose = a => a[0].map((_, c) => a.map(r => r[c]));


var pageGraph = {
  data: function () {
    return {
      routes_flg: ROUTES_FLG || '3',
      preparing: false,
      jpDate: "",
      qs: QueryString.parse(),
      timedata: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
      timedataLoaded: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false,]
    }
  },
  mounted: function () {
    moment.locale("ja");
    this.jpDate = moment(this.qs.date).format('YYYY年MM月DD日(ddd)')

    axios
      .get('/2021_chugoku/cms/past_calendar.json')
      .then((response) => {
        const curDate = moment(this.qs.date)
        response.data.forEach((d) => {
          const date = moment(d.custom.preparing_date)
          if (curDate.isSame(date)) {
            this.preparing = true
          }
        })
      })
    const interval = setInterval(() => {
      this.$forceUpdate()
      global.updateChart("chart1", this.chart1())
      global.updateChart("chart2", this.chart2())
      if (this.timedataLoaded.reduce((a, b) => { return a && b })) {
        clearInterval(interval)
        console.log("end")
      }
    }, 2000)
    axios
      .get('/2021_chugoku/cms/past/'+(this.qs.date.replace(/\//g,""))+'.json')
      .then((response) => {
        response.data.forEach(d=>{
          const time =moment(d.time).format("H")
          this.timedata[time] = d
          this.timedataLoaded[time] = true
        })

      })


  },


  methods: {
    getTimeArray(road_id) {

      return this.timedata.map((roads) => {
        let time = ""

        roads.roads && Object.keys(roads.roads).forEach((road_id2) => {
          if (road_id2 == road_id) {
            time = Math.round(roads.roads[road_id2])
          }
        })
        return time
      })
    },
    chart1() {
      var data = (()=>{
        
        switch (this.routes_flg) {
          case '2':
            return [
              ["時刻"].concat(Object.keys(this.timedata)),
              ["新名神〜名神"].concat(this.getTimeArray("RID_2_1_001").map(this.parseIntZeroNull)),
              ["中国道"].concat(this.getTimeArray("RID_2_1_018").map(this.parseIntZeroNull)),
            ]
            
          case '3':
          default:
            return [
              ["時刻"].concat(Object.keys(this.timedata)),
              ["新名神〜名神"].concat(this.getTimeArray("RID_2_1_001").map(this.parseIntZeroNull)),
              ["中国道〜大阪中央環状線"].concat(this.getTimeArray("RID_2_1_002").map(this.parseIntZeroNull)),
              ["中国道〜阪神高速池田線〜名神"].concat(this.getTimeArray("RID_2_1_003").map(this.parseIntZeroNull))
            ]
        }
      })()

      return transpose(data)
    },
    chart2() {
      var data = (()=>{
        
        switch (this.routes_flg) {
          case '2':
            return [
              ["時刻"].concat(Object.keys(this.timedata)),
              ["名神〜新名神"].concat(this.getTimeArray("RID_2_1_009").map(this.parseIntZeroNull)),
              ["中国道"].concat(this.getTimeArray("RID_2_1_017").map(this.parseIntZeroNull))
            ]
          case '3':
          default:
            return [
              ["時刻"].concat(Object.keys(this.timedata)),
              ["名神〜新名神"].concat(this.getTimeArray("RID_2_1_009").map(this.parseIntZeroNull)),
              ["大阪中央環状線〜中国道"].concat(this.getTimeArray("RID_2_1_010").map(this.parseIntZeroNull)),
              ["名神〜阪神高速池田線〜中国道"].concat(this.getTimeArray("RID_2_1_011").map(this.parseIntZeroNull))
            ]
        }
      })()

      return transpose(data)
    },
    parseIntZeroNull(v){
      v=parseInt(v)
      if(!v){
        v=null
      }
      return v

    }

  },

}

module.exports = pageGraph